/** @format */

import { TLocale } from '@/utils/gatsby/types';
import { TRoom } from '../../../../@ducks/room/declarations';
import { utilityGetRoomMetaTag } from '../../../../@ducks/room/helpers';

const getJsonLdRoom = (
  locale: TLocale,
  room: Omit<
    TRoom,
    | 'accomodationType'
    | 'countryCode'
    | 'flat'
    | 'legalEntity'
    | 'id'
    | 'salableOnline'
    | 'dateDifference'
    | 'resultType'
    | 'bedroomAvailableCount'
  >,
) => {
  const { metaTitle, metaDescription } = utilityGetRoomMetaTag(locale, room as TRoom);
  const getAttendeeCapacity = () => {
    const category = room.roomType;
    switch (category) {
      case 'SingleRoom':
        return 1;
      case 'DoubleRoom':
        return 2;
      case 'TripleRoom':
        return 3;
      case 'FourRoom':
        return 4;
      default:
        return 1;
    }
  };
  const getAmenitiesFlat = () => {
    const filteredObj: Record<string, any> = Object.entries(room.flatFeatures)
      .filter(([key, value]) => value === true)
      .reduce((acc: Record<string, any>, [key, value]) => {
        acc[key] = value;
        return acc;
      }, {});
    return filteredObj;
  };
  const copyAmenitiesTotal: Record<string, any> = { ...room.roomFeatures, ...getAmenitiesFlat() };
  delete copyAmenitiesTotal.size;
  // Media senza duplicati:
  const urlFromMedia = [...new Set<string>(room.media.map(item => item.url))];
  const mapLink = `https://maps.google.com/?q=${room.position.latitude},${room.position.longitude}`;
  const ldJson = {
    '@context': 'https://schema.org/',
    '@type': 'Room',
    name: metaTitle,
    description: metaDescription,
    address: `${room.address} ${room.building.address_number}`,
    amenityFeature: Object.keys(copyAmenitiesTotal),
    branchCode: room.code,
    floorLevel: room.flatFeatures.floor,
    maximumAttendeeCapacity: getAttendeeCapacity(),
    numberOfBathroomsTotal: room.flatFeatures.bathroomCount,
    numberOfBedrooms: room.flatFeatures.bedsCount,
    numberOfRooms: room.flatFeatures.roomsCount,
    photo: urlFromMedia,
    latitude: room.position.latitude,
    longitude: room.position.longitude,
    hasMap: mapLink,
  };
  return ldJson;
};
export default getJsonLdRoom;
